import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex flex-col items-center space-y-4">
        <div className="w-12 h-12 border-4 border-blue-200 border-t-[#4e7ab4] rounded-full animate-spin"></div>
        <p className="text-gray-600"></p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
